import { render, staticRenderFns } from "./SingleImageUploader.vue?vue&type=template&id=25ad25a4&"
import script from "./SingleImageUploader.vue?vue&type=script&lang=ts&"
export * from "./SingleImageUploader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports